import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import store from 'src/redux/store';
import GlobalStyle from 'components/_utility/GlobalStyle/GlobalStyle';
import App from './App';
import { theme } from '@triumph/shared';

const render = () => {
  const rootEl = document.getElementById('purchase-intent-form');
  const contentApiEndpoint = rootEl.dataset.apiEntrypoint;
  const { basepath } = rootEl.dataset;

  const root = createRoot(document.getElementById('purchase-intent-form'));

  root.render(
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <>
          <GlobalStyle />
          <App contentApiEndpoint={contentApiEndpoint} basepath={basepath} />
        </>
      </ThemeProvider>
    </Provider>,
  );
};

render();
